import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Breadcrumb,
	BreadcrumbItem,
} from "reactstrap";
import "assets/scss/website/app.scss";
import InterestImage from "assets/images/interests.png";
import DateImage from "assets/images/date.png";
import ProfileImage from "assets/images/profile_icon.png";
import classnames from "classnames";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import ProfileService from "services/Website/ProfileService";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { handleFieldChange } from "helpers/common";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const Informations = ({ profile }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);

	const [profileData, setProfileData] = useState({
		email: "",
		first_name: "",
		last_name: "",
		phone: "",
		current_password: "",
		password: "",
		password_confirmation: "",
	});
	const [editType, setEditType] = useState("");
	const profileService = new ProfileService();

	useEffect(() => {
		setProfileData({ ...profile });
	}, [profile]);

	const handleFieldChange = (e) => {
		setProfileData({ ...profileData, [e.target.name]: e.target.value });
	};
	const onSubmitHandler = () => {
		if (editType === "password") {
			if (profileData.password !== profileData.password_confirmation) {
				toast.error(`${t("Password confirmation Doesnot match password")}`);
				return;
			}
		}
		let data = {};
		if (editType === "password") {
			data = {
				current_password: profileData.current_password,
				password: profileData.password,
				password_confirmation: profileData.password_confirmation,
			};
		} else {
			data = {
				first_name: profileData.first_name,
				last_name: profileData.last_name,
				email: profileData.email,
				phone: profileData.phone,
			};
		}
		profileService.updateProfile(data).then((response) => {
			if (response && response.status === SuccessOk) {
				toast.success(`${t("Profile Data updated Successfully")}`);
				setEditType("");
			}
		});
	};

	return (
		<div className="websitPages tab-details">
			<div>
				{editType === "" && (
					<div>
						<div className="py-4 px-md-5 px-3">
							<Row className="d-flex justify-content-between">
								<Col md={6}>
									<h3
										className="text-primary fw-bold font-size-26"
										dangerouslySetInnerHTML={{
											__html: t("Personal Information"),
										}}></h3>
								</Col>
								<Col md={6} className="d-flex justify-content-end">
									<button
										className="btn float-end text-decoration-underline text-primary pt-0"
										onClick={() => {
											setEditType("personalData");
										}}>
										{t("Edit")}
									</button>
								</Col>
							</Row>
							<Row className="pt-4 mb-3">
								<Col md={6} xs={6}>
									<CardText tag="h6" className="label">
										{t("First Name")}
									</CardText>
									<CardText tag="p" className="text-brown">
										{profileData.first_name}
									</CardText>
								</Col>
								<Col md={6} xs={6}>
									<CardText tag="h6" className="label">
										{t("Last Name")}
									</CardText>
									<CardText tag="p" className="text-brown">
										{profileData.last_name}
									</CardText>
								</Col>
							</Row>
							<Row className="pt-2 mt-3">
								<Col lg={6} md={12}>
									<CardText tag="h6" className="label">
										{t("Email Address")}
									</CardText>
									<CardText tag="p" className="text-brown pb-3">
										{profileData.email}
									</CardText>
								</Col>
								<Col lg={6} md={12} className="pb-4 pb-lg-0">
									<CardText tag="h6" className="label">
										{t("Mobile Number")}
									</CardText>
									<CardText tag="p" className="text-brown">
										{profileData.phone}
									</CardText>
								</Col>
							</Row>
							<button
								className="btn text-decoration-underline p-0 text-primary"
								onClick={() => {
									setEditType("password");
								}}>
								{t("Change My Account Password")}
							</button>
						</div>
					</div>
				)}
				{editType === "personalData" && (
					<div className="py-4 px-md-5 px-3">
						<div>
							<button
								type="button"
								className="backBtn text-primary"
								onClick={() => {
									setEditType("");
								}}>
								<i
									className={
										AuthData.lang === "ar"
											? "fa font-size-18 fa-chevron-right"
											: "fa font-size-18 fa-chevron-left"
									}></i>
							</button>
							<span
								dangerouslySetInnerHTML={{
									__html: t("Edit Personal Information"),
								}}
								className="text-primary fw-bold font-size-26"></span>
						</div>
						<AvForm
							onValidSubmit={(e, v) => onSubmitHandler("personalData")}
							className="heightForm">
							<Row className="pt-4">
								<Col lg={6} md={6} className="mb-3">
									<label className="label">{t("First Name")}</label>
									<AvField
										name="first_name"
										placeholder={t("First Name")}
										className="form-control"
										onChange={(e) => handleFieldChange(e)}
										value={profileData.first_name}
										required
									/>
								</Col>
								<Col lg={6} md={6} className="mb-3">
									<label className="label">{t("Last Name")}</label>
									<AvField
										name="last_name"
										placeholder={t("Last Name")}
										className="form-control"
										onChange={(e) => handleFieldChange(e)}
										value={profileData.last_name}
										required
									/>
								</Col>
								<Col lg={6} md={6} className="mb-3">
									<label className="label">{t("Email Address")}</label>
									<AvField
										name="email"
										placeholder={t("Email Address")}
										type="email"
										className="form-control"
										onChange={(e) => handleFieldChange(e)}
										value={profileData.email}
										required
									/>
								</Col>
								<Col lg={6} md={6} className="mb-3">
									{/* <AvField
                                        name="phone"
                                        placeholder="(+966) 24681012"
                                        label={t("Mobile Number")}
                                        className="form-control mb-2"
                                        type="number"
                                        required
                                        onChange={(e) => handleFieldChange(e)}
                                        value={profileData.phone}
                                    /> */}
									<label className="label">{t("Mobile Number")}</label>
									<PhoneInput
										country={"eg"}
										enableSearch={true}
										value={profileData?.phone}
										onChange={(e) =>
											setProfileData({ ...profileData, phone: e })
										}
									/>
								</Col>
							</Row>
							<div className="mt-3 d-flex justify-content-end">
								<button
									type="submit"
									className="btn btnSave text-center"
									style={{
										background: "var(--primary-color)",
										borderColor: "var(--primary-color)",
									}}>
									{t("Save Changes")}
								</button>
							</div>
						</AvForm>
					</div>
				)}
				{editType === "password" && (
					<div className="py-4 px-5">
						<div>
							{" "}
							<button
								type="button"
								className="backBtn"
								onClick={() => {
									setEditType("");
								}}>
								<i className="fa font-size-18 fa-chevron-left"></i>
							</button>{" "}
							<span
								dangerouslySetInnerHTML={{
									__html: t("Change My Password"),
								}}
								className="text-primary fw-bold font-size-26"></span>
						</div>
						<AvForm
							onValidSubmit={(e, v) => onSubmitHandler("password")}
							className="heightForm">
							<Row className="pt-4">
								<Col lg={6} md={8}>
									<label className="label">{t("Current Password")}</label>
									<AvField
										name="current_password"
										placeholder={t("Current Password")}
										type="password"
										className="form-control mb-2"
										required
										onChange={(e) => handleFieldChange(e)}
										value={profileData.current_password}
									/>
								</Col>
								<Col lg={6} md={8}>
									<label className="label">{t("New Password")}</label>
									<AvField
										name="password"
										placeholder={t("New Password")}
										type="password"
										className="form-control mb-2"
										required
										onChange={(e) => handleFieldChange(e)}
										value={profileData.password}
									/>
								</Col>
								<Col lg={6} md={8}>
									<label className="label">{t("Re-Type New Password")}</label>
									<AvField
										name="password_confirmation"
										placeholder={t("Re-Type New Password")}
										type="password"
										className="form-control mb-2"
										required
										onChange={(e) => handleFieldChange(e)}
										value={profileData.password_confirmation}
									/>
								</Col>
							</Row>
							<div className="mt-3 d-flex justify-content-end">
								<button
									style={{
										background: "var(--primary-color)",
										borderColor: "var(--primary-color)",
									}}
									className="btn btnSave text-center">
									{t("Change Password")}
								</button>
							</div>
						</AvForm>
					</div>
				)}
			</div>
		</div>
	);
};

export default Informations;
